import { connectHook } from 'app/common/components/connect-hook';
import { BranchSwitcher } from './branch-switcher';
import { useBranchSwitcher } from './branch-switcher-hook';

export default connectHook(BranchSwitcher, useBranchSwitcher);
